module.exports = __webpack_public_path__ + "static/media/iPhone14-3.2638061d.png";